export const PASSWORD_REQUIREMENTS_MESSAGE =
  'Password must be at least 8 characters long and include at least one uppercase letter and one number.';

export const validatePasswordStrength = (password = '') => {
  const value = password || '';
  const hasMinLength = value.length >= 8;
  const hasNumber = /[0-9]/.test(value);
  const hasUppercase = /[A-Z]/.test(value);

  if (hasMinLength && hasNumber && hasUppercase) {
    return { valid: true, message: '' };
  }

  return {
    valid: false,
    message: PASSWORD_REQUIREMENTS_MESSAGE,
  };
};
